/** @module csi/action/ThreeDMaterialUploadController */
define([
	"dojo/_base/declare",
	"dojo/Deferred",
	"src/c8-platform/service/aggregateStoreService",
	"underscore",
	"csi/action/ActionView",
	"csi/action/Controller",
	"csi/action/NewFileController",
	"csi/comm/Aspera",
	"csi/comm/PostRequest",
	"csi/def",
	"csi/html",
	"csi/image/_base",
	"csi/locale",
	"csi/reflection",
	"csi/sessionConstants",
	"csi/util",
	"csi/xml"
], function (declare, Deferred,{clearAggregateStoreResponsesByNodeType}, _, ActionView, Controller, NewFileController, Aspera, PostRequest, def, html, csiImage, locale, reflection, sessionConstants, util, xml) {

	return declare(NewFileController, {

		/** @property {boolean} canceledFileSelect - true when user cancels Aspera file select */
		canceledFileSelect: false,

		/**
		 * Return ActionView for form if 3dMaterialForm view is not available.
		 * @return {ActionView}
		 */
		getActionView: function () {
			var rc = reflection.getClass("Document");
			var defView = def.getClassViewDef(rc, "3DMaterialForm");
			return new ActionView(this, defView);
		},

		/**
		 * Tests whether an extension is a Clo hardware file extension
		 * @param {string} extension
		 * @return {boolean}
		 */
		isCloType: function (extension) {
			let extensions = ["zfab", "trm", "btn", "bth", "zpac", "sst", "zsp", "zpl", "zsd"];
			return _.contains(extensions, extension);
		},

		/**
		 * @override
		 * Publish request to create new 3d material document
		 */
		process: function () {
			const node = this.getNode();
			const fd = this.getFormData();
			const docName = fd.getFieldValue(xml.ATTR_NAME);
			if (Aspera.isEnabled()) {
				this.disableActionView(true);
				this.closeDialog();
				this.canceledFileSelect = false;
				const bMaterial = true;
				const bPropagate = fd.getFieldValue("3DPropagateToExistingColorMaterials");
				Aspera.upload3DFile(node.DocumentsAndComments, docName, this.popupView.asperaData, this, bMaterial, bPropagate).then(
					(response) => {
						this._onPublishResponse(response);
					},
					(msg) => {
						// Do not show error if user cancels file selection, but show error if Aspera license is expired
						this.m_error = msg || "";
						if (!Aspera.isValid()) {
							this.canceledFileSelect = true;
						}
						this.postProcess(false);
					}
				);
				return;
			}
			const req = new PostRequest("SiteAdmin", "Create3DMaterial");
			req.addParameter("Name", fd.getFieldValue(xml.ATTR_NAME));
			req.addParameter("ParentURL", node.DocumentsAndComments);
			req.addParameter("SessionURL", sessionConstants.sessionUrl);
			req.addFiles(fd.getFieldValueAsFile("SourceFile"), "SourceFile");
			req.addParameter("DefaultImage", fd.getFieldValue("DefaultImage"));
			req.addParameter("Propagate3DMaterials", fd.getFieldValue("3DPropagateToExistingColorMaterials"));

			if (this.isCloType(util.getFileExtension(fd.getFieldValue("SourceFile")))) {
				const item = fd.getField("DefaultImage").m_control.item;

				if (item && item.rawSrc) {
					req.addParameter("DefaultImageFile", html.b64toBlob(item.rawSrc, "image/" + item.ext));
				}
			}

			this.waitForPublish(req.post(), true);
		},

		/**
		 * @override
		 * Enable Action View in case of server side validation error
		 */
		postProcess: function () {
			this.inherited(arguments);
			if (Aspera.isEnabled()) {
				this.disableActionView(false);
			}

			// After a new document is created, clear the aggregate store responses so that the new document is visible
			clearAggregateStoreResponsesByNodeType("Document");
		},

		/**
		 * @override
		 * Track URL of new document
		 */
		onPublishResponse: function (response) {
			this.m_urlNode = response.getResultNode().$URL;
		},

		/**
		 * @override
		 * If user cancels file selection, don't show error
		 */
		getError: function (suffix, params) {
			if (Aspera.isValid()) {
				return this.m_error;
			}
			return this.canceledFileSelect ? null : this.inherited(arguments);
		}
	});
});